/**
 * Clear-all control for the RMA list filters sidebar.
 * Clears applied filters, reloads page 1, and optionally notifies the parent (e.g. close tablet drawer).
 */
import { observer } from "mobx-react";
import FontBody2 from "../../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../../../components/fonts/font-props";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import RmaListFiltersStore from "../../../../../rma-list-page/stores/rma-list-filters-store";
import {
    MANAGE_RETURNS_DESIGN_VERSION,
    trackManageReturnsListEvent,
} from "../../../../../utils/manage-returns-list-mixpanel";
import rmaPagedListStore from "../../../../stores/rma-tabs-paged-list-store";


interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    disabled: boolean;
    onFiltersApplied?: () => void;
}

const RmaListFiltersSidebarClearAll: React.FC<IProps> = observer(
    ({ rmaListFiltersStore, disabled, onFiltersApplied }) => {
        const { getTranslation } = useDashboardTranslation();
        const scope = "dashboard-returns-page";
        const appliedCount = rmaListFiltersStore.appliedWiredSidebarFilterCount;
        const clearAllLabel = getTranslation("FILTERS_CLEAR_ALL", scope);

        const onClearAll = () => {
            trackManageReturnsListEvent("d&_filters_clear_all", MANAGE_RETURNS_DESIGN_VERSION.V2);
            rmaListFiltersStore.clearAll();
            rmaPagedListStore.bulkSelectionStore.clear();
            rmaPagedListStore.loadPage(1);
            onFiltersApplied?.();
        };

        return (
            <button
                type="button"
                className="rma-list-filters-sidebar__clear-all"
                disabled={disabled || appliedCount === 0}
                onClick={onClearAll}
            >
                <FontBody2 color={FONT_COLOR.ACCENT1}>{clearAllLabel}</FontBody2>
            </button>
        );
    },
);

export default RmaListFiltersSidebarClearAll;
